import { render, staticRenderFns } from "./crossing.vue?vue&type=template&id=4a9022a4&scoped=true&"
import script from "./crossing.vue?vue&type=script&lang=ts&"
export * from "./crossing.vue?vue&type=script&lang=ts&"
import style0 from "./crossing.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./crossing.vue?vue&type=style&index=1&id=4a9022a4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a9022a4",
  null
  
)

export default component.exports